import { render, staticRenderFns } from "./SpecificationComponent.vue?vue&type=template&id=1545b84d"
import script from "./SpecificationComponent.vue?vue&type=script&lang=js"
export * from "./SpecificationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports